export default __webpack_public_path__ + "static/media/upload-dialog-select.7733e0a5.svg";